import { TagDescription } from "@reduxjs/toolkit/query"
import { RoutePlanningModel } from "src/features/route-planning/models"
import {
  apiConstants,
  apiPathConstants,
  InvalidateTagsType,
} from "src/features/shared-module/constants"
import { appToastConstants } from "src/features/shared-module/constants/app-toast.constants"
import { apiToastHandler } from "src/features/shared-module/functions"
import { baseApi } from "../../../app/apis"

const routePlanningListTag: TagDescription<InvalidateTagsType>[] = [
  {
    type: "Route Planning",
    id: "ROUTE_PLANNING_TAG_LIST",
  },
]

const routePlanningApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRouteList: builder.query({
      query: () => apiConstants.GET_ROUTE_LIST,
      providesTags: routePlanningListTag,
    }),

    createRoute: builder.mutation<RoutePlanningModel, RoutePlanningModel>({
      query: (route: RoutePlanningModel) => ({
        url: apiConstants.CREATE_ROUTE,
        method: "POST",
        body: route,
      }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        apiToastHandler(
          { dispatch, queryFulfilled },
          appToastConstants.routePlanCreate,
          routePlanningListTag,
          routePlanningApi.util.invalidateTags,
        )
      },
    }),

    updateRoute: builder.mutation({
      query: ({ id, ...route }) => ({
        url: apiConstants.UPDATE_ROUTE.replace(
          `:${apiPathConstants.routeId}`,
          id,
        ),
        method: "PUT",
        body: route,
      }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        apiToastHandler(
          { dispatch, queryFulfilled },
          appToastConstants.routePlanUpdate,
          routePlanningListTag,
          routePlanningApi.util.invalidateTags,
        )
      },
    }),

    deleteRoute: builder.mutation({
      query: (id) => ({
        url: apiConstants.UPDATE_ROUTE.replace(
          `:${apiPathConstants.routeId}`,
          id,
        ),
        method: "DELETE",
      }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        apiToastHandler(
          { dispatch, queryFulfilled },
          appToastConstants.routePlanDelete,
          routePlanningListTag,
          routePlanningApi.util.invalidateTags,
        )
      },
    }),
  }),
})

export const {
  useCreateRouteMutation,
  useUpdateRouteMutation,
  useGetRouteListQuery,
  useDeleteRouteMutation,
} = routePlanningApi
